<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            توزيع الموظفين حسب الفئة الوظيفية
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            قائمة الكوادر الصحية المفصّلة حسب الوظيفة
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-workforce')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">70</div>
          <div class="kpi-label">أطباء فعليون من 85 معتمد</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">150</div>
          <div class="kpi-label">ممرضون من 240 معتمد</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">40</div>
          <div class="kpi-label">قابلات من 60 معتمد</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">10</div>
          <div class="kpi-label">صيدلانيون من 40 معتمد</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">توزيع الكوادر حسب الفئة الوظيفية والنوع</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>الفئة الوظيفية</th>
            <th>المعتمد</th>
            <th>الفعلي</th>
            <th>الفجوة</th>
            <th>ذكور</th>
            <th>إناث</th>
            <th>نسبة الإناث%</th>
            <th>حالة الكفاية</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in staffCategories" :key="item.category">
            <td class="font-weight-bold">{{ item.category }}</td>
            <td>{{ item.approved }}</td>
            <td>{{ item.actual }}</td>
            <td class="text-red-darken-2 font-weight-bold">{{ item.gap }}</td>
            <td>{{ item.male }}</td>
            <td>{{ item.female }}</td>
            <td>{{ item.femaleRate }}</td>
            <td>
              <v-chip
                :color="adequacyColor(item.adequacy)"
                size="small"
                variant="flat"
              >
                {{ item.adequacy }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const staffCategories = [
  {
    category: "أطباء متخصصون",
    approved: 45,
    actual: 38,
    gap: -7,
    male: 30,
    female: 8,
    femaleRate: "21%",
    adequacy: 84,
  },
  {
    category: "أطباء عامون",
    approved: 40,
    actual: 32,
    gap: -8,
    male: 20,
    female: 12,
    femaleRate: "38%",
    adequacy: 80,
  },
  {
    category: "ممرضون",
    approved: 180,
    actual: 110,
    gap: -70,
    male: 60,
    female: 50,
    femaleRate: "45%",
    adequacy: 61,
  },
  {
    category: "قابلات",
    approved: 60,
    actual: 40,
    gap: -20,
    male: 0,
    female: 40,
    femaleRate: "100%",
    adequacy: 67,
  },
  {
    category: "صيدلانيون",
    approved: 40,
    actual: 10,
    gap: -30,
    male: 7,
    female: 3,
    femaleRate: "30%",
    adequacy: 25,
  },
  {
    category: "فنيو مختبر",
    approved: 30,
    actual: 8,
    gap: -22,
    male: 6,
    female: 2,
    femaleRate: "25%",
    adequacy: 27,
  },
  {
    category: "فنيو أشعة",
    approved: 20,
    actual: 5,
    gap: -15,
    male: 4,
    female: 1,
    femaleRate: "20%",
    adequacy: 25,
  },
  {
    category: "إداريون",
    approved: 60,
    actual: 14,
    gap: -46,
    male: 10,
    female: 4,
    femaleRate: "29%",
    adequacy: 23,
  },
  {
    category: "عمال صحة مجتمعية",
    approved: 30,
    actual: 22,
    gap: -8,
    male: 5,
    female: 17,
    femaleRate: "77%",
    adequacy: 73,
  },
];

const adequacyColor = (value) => {
  if (value >= 60) return "green";
  if (value >= 40) return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
